const getScope = (state) => state.modules.auth.login;

export const getError = (state) => getScope(state).error;
export const getIsFetching = (state) => getScope(state).isFetching;

export const getAuthStep = (state) => getScope(state).authStep;
export const getIsDiscovering = (state) => getScope(state).isDiscovering;

export const getShowTermsAcceptanceModal = (state) =>
  getScope(state).showTermsAcceptanceModal;

export const getPasswordResetSent = (state) =>
  getScope(state).passwordResetSent;

export const getIsTwoFactorRequired = (state) =>
  getScope(state).isTwoFactorRequired;
